module.exports = __webpack_public_path__ + "static/pl-516abf3480cd4af804987e9d2f32a1c8.webm";